import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createData, updateData } from "@api/setting/dictionary";
export default {
  props: {
    id: {},
    data: {},
    typeName: {},
    type: {},
    types: {},
    code: {},
    first: {}
  },
  data: function data() {
    return {
      form: {
        n04Value: undefined,
        n04ExtValue: '',
        n04Enabled: false,
        n04Sort: 0
      },
      rules: {
        n04Value: [{
          required: true,
          message: '请输入字典值',
          trigger: 'change'
        }]
      },
      loading: false
    };
  },
  methods: {
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var handler, params, _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$checkForm();
            case 1:
              _this.loading = true;
              handler = {
                create: createData,
                edit: updateData
              };
              params = {};
              if (_this.type === 'create' && _this.first) {
                params.n04TableName = _this.first.n04TableName;
                params.n04Length = _this.first.n04Length;
              }
              _context.n = 2;
              return _this.$awaitTo(handler[_this.type](_objectSpread(_objectSpread({}, _this.form), {}, {
                n04FieldName: _this.code,
                n04Name: _this.typeName,
                n04Class: true
              }, params)));
            case 2:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              _this.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _this.$message.success('操作成功');
              _this.$emit('submit');
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  },
  created: function created() {
    if (this.id) {
      this.form = _objectSpread(_objectSpread({}, this.form), this.data);
    }
  }
};